// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «ШІ-асистент» (AI assistant, ключ `ai`, група `basic`). */
export const aiAssistantManifest: IModuleManifest = {
  key: 'ai',
  group: 'basic',
  slug: 'ai-assistant',
  prefix: 'AI',
  name: { en: 'AI assistant', uk: 'ШІ-асистент' },
  entities: [
    { key: 'ai', slug: 'ai', name: { en: 'AI assistant', uk: 'ШІ-асистент' }, main: true },
  ],
  loadState: () => import('./state/aiAssistantSlice').then((m) => m.aiAssistantSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
